// Note the use of expose-loader to ensure that "$" and "jQuery" are exposed on the global scope for usage elsewhere
import 'expose-loader?exposes=$,jQuery!jquery';
import 'jquery-ajax-unobtrusive';
import 'select2';
// Note the use of imports-loader to ensure that "this" is set to the window object, so that this legacy
// javascript library can register itself correctly.
import 'imports-loader?wrapper=window!jquery-throttle-debounce';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
// Note that we are referencing a specific js file inside this NPM package. 
import '@sentry-insurance/InternalFrontendTemplate/dist/jquery.validate.unobtrusive.sentry.js';
import 'jquery-placeholder';
import 'bootbox';
import 'ladda';
import '../Scripts/spin.js';